import { useEffect, useMemo, useRef } from "react";

import { selectRandomVariant } from "../../../../../utils/abTesting";
import { CarrierVoluntellLandingPageVariant } from "../types";
import { CarrierVoluntellActivationPage1 } from "./CarrierVoluntellActivationPage1";
import { CarrierVoluntellActivationPage2 } from "./CarrierVoluntellActivationPage2";

import type { ActivationPageProps } from "../types";

interface CarrierVoluntellActivationPageRouterProps extends ActivationPageProps {
  onMetadataReady?: (metadata: Record<string, string>) => void;
}

export function CarrierVoluntellActivationPageRouter(
  props: CarrierVoluntellActivationPageRouterProps,
) {
  const { passwordField, submitButton, errorMessage, onMetadataReady } = props;

  // Roll the A/B variant once on mount. Computing it during render would
  // re-roll it on every keystroke (via Math.random), remounting a different
  // page and wiping the password field.
  const variant = useMemo(
    () => selectRandomVariant(CarrierVoluntellLandingPageVariant),
    [],
  );

  const calledMetadataRef = useRef<boolean>(false);

  useEffect(() => {
    if (calledMetadataRef.current) return;
    onMetadataReady?.({ landingPageVariant: variant });
    calledMetadataRef.current = true;
  }, [variant, onMetadataReady]);

  const pageProps = {
    passwordField,
    submitButton,
    errorMessage,
  };

  switch (variant) {
    case CarrierVoluntellLandingPageVariant.V2:
      return <CarrierVoluntellActivationPage2 {...pageProps} />;
    case CarrierVoluntellLandingPageVariant.V1:
    default:
      return <CarrierVoluntellActivationPage1 {...pageProps} />;
  }
}
